import PropTypes from 'prop-types';
import keyMirror from "ramda-extension/es/keyMirror";
export const actionTypes = keyMirror({
    ADD_ERROR: null,
    REMOVE_ERROR: null,
    CLEAR_ERRORS: null,
    SHOW_ERROR_SINGLE: null,
    CLOSE_ERROR_SINGLE: null,
    SHOW_ERROR_MULTIPLE: null,
    CLOSE_ERROR_MULTIPLE: null,
    SENT_SUCCESSFULLY: null,
    SENT_FAILED: null,
    DELETE_SENT: null,
    REMOVE_ERROR_SINGLE: null,
    HIDE_ERROR: null,
    HIDE_ERRORS: null,
    SHOW_ERRORS: null,
    SHOW_ERROR_FULLSCREEN: null
});
export const errorPropType = PropTypes.shape({
    heading: PropTypes.string,
    longDescription: PropTypes.string,
    shortDescription: PropTypes.string,
    timestamp: PropTypes.string,
    traceId: PropTypes.string,
    screen: PropTypes.string,
    sentSuccess: PropTypes.bool,
    sentFail: PropTypes.bool,
    showReport: PropTypes.bool,
    unclosable: PropTypes.bool,
    components: PropTypes.shape({
        Header: PropTypes.elementType,
        Body: PropTypes.elementType,
        Actions: PropTypes.elementType,
        Content: PropTypes.elementType,
        dialogProps: PropTypes.object
    })
});
